import React from 'react';
import SignInWithGoogle from '../SignInWithGoogle/SignInWithGoogle';

const LoginPage = () => {
    return (
        <div>
            <SignInWithGoogle />
        </div>
    );
};

export default LoginPage;